import { toastTypes } from "../actions/types";

const initialState = {
  show: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case toastTypes.SHOW_TOAST:
      return {
        ...state,
        show: !state.show
      }
    default:
      return state;
  }
}